import { Breadcrumbs, Button, Link, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { NavLink } from "components/navigation/NavLink";
import { useContext } from "react";
import { TextFieldContext } from "context/TextFieldContext";

interface Props {}

export function AppBreadcrumbs(props: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { textFieldRef } = useContext(TextFieldContext);

  function onClickHeader() {
    navigate("/");
    if (textFieldRef && textFieldRef.current) textFieldRef.current.value = "";
  }

  return (
    <Styles>
      <Button
        className="main-button"
        variant="breadcrumb"
        onClick={onClickHeader}
      >
        {t("label.climateLayersCatalog")}
      </Button>
      <Breadcrumbs separator="›">
        <Link component={NavLink} variant="breadcrumb" to={"/"} end>
          {t("label.catalog")}
        </Link>
        <Link variant="breadcrumb" className="disabled">
          {t("label.layerInDetail")}
        </Link>
      </Breadcrumbs>
    </Styles>
  );
}

const Styles = styled("div")`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  .main-button {
    margin-right: ${({ theme }) => theme.spacing(2)};
  }

  .MuiBreadcrumbs-root {
    display: inline-block;
  }
  .disabled {
    pointer-events: none;
    color: inherit;
  }
`;
